<ng-container *transloco="let t">
  <div class="relative w-full border-b border-stroke-soft mb-8 shrink-0">
    <ul class="flex overflow-x-auto list-none gap-2 no-scrollbar scroll-smooth">
      @for (tab of tabs(); track $index) {
      <li
        #tabItem
        tabindex="0"
        (keydown)="selectTab($index)"
        (click)="selectTab($index)"
        [class]="
          [
            selectedIndex() === $index ? 'tab--active' : '',
            tabIndexWithValidationError() === $index ? 'tab--invalid' : ''
          ].join(' ')
        "
        class="whitespace-nowrap font-medium h-10 flex items-center px-4 text-base text-ink-muted cursor-pointer transition-colors duration-200"
      >
        {{ tab.title() }}
        @if (tabIndexWithValidationError() === $index) {
        <mat-icon class="size-3.5! ms-1.5" svgIcon="danger-triangle-bold"></mat-icon>
        }
      </li>
      }
    </ul>
  </div>
  <div [class]="mainContainerClasses()">
    <div [class]="tabsContainerClasses()">
      <ng-container *ngTemplateOutlet="getTabTemplateByIndex(selectedIndex())!"></ng-container>
    </div>
    <div class="flex flex-col-reverse md:flex-row md:items-center md:justify-end gap-4 mt-10 lg:mt-0">
      <div class="w-full md:w-auto">
        <dss-libs-ui-button
          variant="outline"
          color="danger"
          [label]="'DISCARD'"
          (clickOutput)="onDiscardClick()"
          class="w-full"
        ></dss-libs-ui-button>
      </div>
      <dss-libs-ui-button
        type="submit"
        [label]="'CONTRACT_ORDER.SEND_ORDER'"
        [disabled]="!isSubmitButtonEnabled()"
        appliedClasses="px-10 py-2.5 h-11 rounded-[8px] text-[15px] font-semibold"
        class="w-full md:w-auto"
      ></dss-libs-ui-button>
    </div>
  </div>
</ng-container>
